import { FieldDataEntity, FieldDataEntityApi } from '../FieldData';
import {
  FieldDefaultValueEntity,
  FieldDefaultValueEntityApi,
} from '../FieldDefaultValue';

export enum FillingMethod {
  import = 'import',
  form = 'form',
}

/**
 * Сущность поля обычной формы  из апишки
 */
export type FormFieldEntityApi = {
  /**
   * Флаг, показывающий, схлопнута ли колонка или нет
   */
  default_visibility: boolean;
  /**
   * Информация о поле из каталога
   */
  field_data: FieldDataEntityApi;
  /**
   * Способ заполнения
   */
  filling_method: FillingMethod;
  /**
   * id формы
   */
  form_id: number;
  /**
   * id поля
   * */
  id: string;
  /**
   * Отображается ли колонка для руководителя ( настраивается HRом )
   */
  supervisor_visibility: boolean;
  /**
   * Отображается ли колонка на сводном экране
   */
  pivot_screen_visibility: boolean;
  /**
   * Разрешено ли редактирование импортированных данных
   */
  import_editable: boolean;
  /*
   * Значение по умолчанию
   * */
  default_value: FieldDefaultValueEntityApi | null;
};

/** Сущность поля для рендера внутри таблицы*/
export type FormFieldEntity = {
  fillingMethod: FillingMethod;
  defaultVisibility: boolean;
  supervisorVisibility: boolean;
  fieldData: FieldDataEntity;
  formId: number;
  pivotScreenVisibility: boolean;
  importEditable: boolean;
  defaultValue: FieldDefaultValueEntity | null;
  id: string;
};
